__turbopack_context__.v({
  "checked": "fsK7oW_checked",
  "container": "fsK7oW_container",
  "hidden": "fsK7oW_hidden",
  "label": "fsK7oW_label",
  "radioContainer": "fsK7oW_radioContainer",
  "unchecked": "fsK7oW_unchecked",
});
